import { __decorate } from "tslib";
import BScroll from "better-scroll";
import { Component, Vue, Prop } from "vue-property-decorator";
let DivScroll = class DivScroll extends Vue {
    constructor() {
        super(...arguments);
        this.scroll = {};
    }
    mounted() {
        this.$nextTick(() => {
            //$refs绑定元素
            this.scroll = new BScroll(this.$refs.wrapper, {
                //开启点击事件 默认为false
                click: true,
                mouseWheel: true,
                preventDefault: false,
                scrollbar: {
                    fade: true,
                    interactive: false,
                },
            });
        });
    }
};
__decorate([
    Prop({ default: "" })
], DivScroll.prototype, "contentClass", void 0);
DivScroll = __decorate([
    Component
], DivScroll);
export default DivScroll;
